import { useContext } from 'react'

import { availableLanguagesForUser } from '@/common/constants'
import AppContext from '@/common/context/app.context'

import { defaultSupportedLanguages } from './constants'

const useStoreLanguages = () => {
  const { info } = useContext(AppContext)

  const supportedLanguages = info?.selectedStore?.supported_languages || defaultSupportedLanguages

  return availableLanguagesForUser.filter(language => supportedLanguages.includes(language))
}

export default useStoreLanguages
